import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiDollarSign, FiCheck, FiArrowRight } = FiIcons;

const PriceMatchGuarantee = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    competitorPrice: '',
    dealerName: '',
    vehicleDetails: '',
    customerName: '',
    phone: '',
    email: ''
  });

  const guarantees = [
    {
      icon: FiDollarSign,
      title: "Price Match Guarantee",
      description: "We'll match any legitimate competitor's price on identical vehicles"
    },
    {
      icon: FiShield,
      title: "No Hidden Fees",
      description: "Transparent pricing with all fees disclosed upfront"
    },
    {
      icon: FiCheck,
      title: "Best Value Promise",
      description: "If you find a better total value within 3 days, we'll refund the difference"
    }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Price match request submitted! We\'ll review and contact you within 2 hours.');
    setShowForm(false);
    setFormData({
      competitorPrice: '',
      dealerName: '',
      vehicleDetails: '',
      customerName: '',
      phone: '',
      email: ''
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gray-800 rounded-lg p-6 border border-gray-700"
    >
      <h3 className="text-xl font-bold text-white mb-4 flex items-center">
        <SafeIcon icon={FiShield} className="w-5 h-5 mr-2 text-audi-red" />
        Our Guarantees
      </h3>

      <div className="space-y-4 mb-6">
        {guarantees.map((guarantee, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-8 h-8 bg-audi-red rounded-lg flex items-center justify-center flex-shrink-0">
              <SafeIcon icon={guarantee.icon} className="w-4 h-4 text-white" />
            </div>
            <div>
              <h4 className="font-semibold text-white">{guarantee.title}</h4>
              <p className="text-gray-300 text-sm">{guarantee.description}</p>
            </div>
          </div>
        ))}
      </div>

      {!showForm ? (
        <button
          onClick={() => setShowForm(true)}
          className="w-full bg-audi-red hover:bg-red-700 text-white py-3 px-4 rounded-lg font-semibold transition-colors flex items-center justify-center"
        >
          Request Price Match
          <SafeIcon icon={FiArrowRight} className="w-4 h-4 ml-2" />
        </button>
      ) : (
        <motion.form
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="Competitor's Price"
              value={formData.competitorPrice}
              onChange={(e) => setFormData({...formData, competitorPrice: e.target.value})}
              className="bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-audi-red"
              required
            />
            <input
              type="text"
              placeholder="Competitor Dealer Name"
              value={formData.dealerName}
              onChange={(e) => setFormData({...formData, dealerName: e.target.value})}
              className="bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-audi-red"
              required
            />
          </div>
          
          <textarea
            placeholder="Vehicle details (Year, Model, Trim, Mileage, etc.)"
            value={formData.vehicleDetails}
            onChange={(e) => setFormData({...formData, vehicleDetails: e.target.value})}
            rows="2"
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-audi-red resize-none"
            required
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="Your Name"
              value={formData.customerName}
              onChange={(e) => setFormData({...formData, customerName: e.target.value})}
              className="bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-audi-red"
              required
            />
            <input
              type="tel"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              className="bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-audi-red"
              required
            />
            <input
              type="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-audi-red"
              required
            />
          </div>

          <div className="flex space-x-3">
            <button
              type="submit"
              className="flex-1 bg-audi-red hover:bg-red-700 text-white py-2 px-4 rounded-lg font-semibold transition-colors"
            >
              Submit Price Match Request
            </button>
            <button
              type="button"
              onClick={() => setShowForm(false)}
              className="px-4 py-2 text-gray-400 hover:text-white transition-colors"
            >
              Cancel
            </button>
          </div>
        </motion.form>
      )}

      {/* Trust Badge */}
      <div className="mt-4 p-3 bg-green-900/20 border border-green-800 rounded-lg">
        <div className="flex items-center space-x-2">
          <SafeIcon icon={FiCheck} className="w-4 h-4 text-green-400" />
          <span className="text-green-400 text-sm font-medium">
            Guaranteed 2-hour response on all price match requests
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default PriceMatchGuarantee;